import type { Attachment } from 'shiftNotes/_types';
import { isDocumentMimeType } from 'shiftNotes/helpers/noteCaptureAttachmentLimits';

export default function isDocumentAttachment(attachment: Attachment): boolean {
  return Boolean(
    attachment.mime_type && isDocumentMimeType(attachment.mime_type)
  );
}
